import * as styles from './StarRatingInput.css';

import { type FC, useState } from 'react';

import { Text, Box, IconStar } from 'braid-design-system';
import TextButton from '../TextButton';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

interface Props {
  onClick: (x: number) => number;
  rating: number;
  idPrefix: string;
  fullName: string;
}

export const StarRatingInput: FC<Props> = ({
  onClick,
  rating,
  idPrefix,
  fullName,
}) => {
  const [currentHoverIndex, setCurrentHoverIndex] = useState(0);
  const { t } = useTranslations(translations);
  const onStarClick = (ratingValue: number) => {
    const newRatingValue = onClick(ratingValue);
    setCurrentHoverIndex(newRatingValue);
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="flexStart">
      <Box className={styles.starRatingInput}>
        <Box display="flex" className={{ [styles.detailedSpacing]: true }}>
          {[...Array(5)].map((e, i) => {
            const index = i + 1;
            return (
              <Box
                key={`star-rating-${index}`}
                display="flex"
                justifyContent="flexStart"
                alignItems="center"
                className={styles.starRatingInputOption}
                onMouseEnter={() => setCurrentHoverIndex(index)}
                onMouseLeave={() => setCurrentHoverIndex(0)}
              >
                <Text>
                  <Box className={styles.star}>
                    <TextButton
                      aria-label={t('Star rating', { index })}
                      data-testid={`rating_${index}`}
                      onClick={() => onStarClick(index)}
                    >
                      <IconStar
                        active={rating >= index || currentHoverIndex >= index}
                        title={`${fullName} ${t('Star rating image')} ${index}`}
                        titleId={`${idPrefix}-starRatingSvg${index}`}
                      />
                    </TextButton>
                  </Box>
                </Text>
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
